import React from 'react';
import { ExternalLink } from 'lucide-react';
import { useAdminAuth } from '@/context/AdminAuthContext';

export default function SettingsPanel() {
  const { logout } = useAdminAuth();

  return (
    <div className="space-y-6 max-w-xl animate-in fade-in duration-400">
      <div>
        <h1
          className="text-[1.75rem] font-semibold text-[#1A2B3C] tracking-tight"
          style={{ fontFamily: '"Playfair Display", Georgia, serif' }}
        >
          Settings
        </h1>
        <p className="text-sm text-[#6B7C90] mt-1">Admin portal notes</p>
      </div>

      <div className="rounded-2xl bg-white/80 backdrop-blur-sm ring-1 ring-[#E2EBF4] p-6 space-y-6 text-sm text-[#5A6B7D]">
        <div>
          <h2 className="font-semibold text-[#1A2B3C] mb-1.5">Authentication</h2>
          <p>
            Sign in with your admin email and password. A session token is stored in
            browser sessionStorage until you sign out or close the tab. Protected APIs
            use the <code className="text-xs bg-[#F0F4F8] px-1.5 py-0.5 rounded">X-Admin-Token</code> header.
          </p>
        </div>
        <div>
          <h2 className="font-semibold text-[#1A2B3C] mb-1.5">Data storage</h2>
          <p>
            Appointments, registrations, and contact messages are saved to MongoDB when connected.
            Contact and registration submissions still email staff when the database is unavailable.
          </p>
        </div>
        <div>
          <h2 className="font-semibold text-[#1A2B3C] mb-1.5">Public site links</h2>
          <ul className="space-y-2 mt-2">
            <li>
              <a href="/appointment" className="text-[#0888F8] hover:underline inline-flex items-center gap-1">
                Book appointment <ExternalLink size={12} />
              </a>
            </li>
            <li>
              <a href="/tour-registration" className="text-[#0888F8] hover:underline inline-flex items-center gap-1">
                Tour registration <ExternalLink size={12} />
              </a>
            </li>
            <li>
              <a href="/contact" className="text-[#0888F8] hover:underline inline-flex items-center gap-1">
                Contact form <ExternalLink size={12} />
              </a>
            </li>
          </ul>
        </div>
        <button
          type="button"
          onClick={logout}
          className="text-red-600 hover:text-red-700 font-medium"
        >
          Sign out of admin
        </button>
      </div>
    </div>
  );
}
